import * as React from 'react';

interface AddLaterRadioTypes {
	onChange?: any;
	value?: boolean;
	className?: string;
	changeToUseExisting?: boolean;
}

const AddLaterRadio: React.FC<AddLaterRadioTypes> = ({ onChange, value, className, changeToUseExisting }) => {
	const handleChange = () => {
		if (onChange) {
			onChange(!value);
		}
	};

	return (
		<div className={`add-later-radio form-group ${className}`}>
			<div className="radio-input">
				<input
					name="radio"
					checked={value}
					onChange={() => handleChange()}
					onClick={() => handleChange()}
					type="radio"
					placeholder="add later"
					title=""
				/>
				<label htmlFor="radio">
					{changeToUseExisting === true ? 'Use existing (shown below)' : 'I’ll add this later or not required'}
				</label>
			</div>

			{changeToUseExisting === true ? null : <p>This may be required by the organisation</p>}
		</div>
	);
};

export default AddLaterRadio;
